import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Banner from './banner';
import Header from './header';
import Modules from './modules';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const bannerImg = content.bannerImg || '';
        const headerData = {
            title: content.title || '',
            introduction: content.introduction || '',
        };

        headerData.subTitle = [];
        content.modules.forEach(item => {
            if (item.title) {
                headerData.subTitle.push(item.title);
            }
        });

        return (
            <Fragment>
                <Banner content={bannerImg} />
                <Header content={headerData} />
                {content.modules.map((item, index) => <Modules key={index} content={item} tagIndex={`tag${index}`} />)}
            </Fragment>
        );
    }
}

export default errorBoundary(Layout);
